import axios from "@/axios";
import { Message } from "element-ui";

const getDefaultState = () => {
  return {
    tasks: [],
    recordsTotal: 0,
    loading: false,
    filters: {
      search: "",
      url: "",
      dateFrom: null,
      dateTo: null,
    },
    pagination: {
      offset: 0,
      limit: 25,
    },
  };
};

const moduleExecutiveSummary = {
  state: getDefaultState(),
  getters: {
    getExecutiveSummaryTasks(state) {
      return state.tasks;
    },
    getExecutiveSummaryRecordsTotal(state) {
      return state.recordsTotal;
    },
    getExecutiveSummaryLoading(state) {
      return state.loading;
    },
    getExecutiveSummaryFilters(state) {
      return state.filters;
    },
    getExecutiveSummaryPagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setExecutiveSummaryTasks(state, tasks) {
      state.tasks = tasks;
    },
    setExecutiveSummaryRecordsTotal(state, total) {
      state.recordsTotal = total;
    },
    setExecutiveSummaryLoading(state, loading) {
      state.loading = loading;
    },
    setExecutiveSummaryFilters(state, filters) {
      state.filters = { ...state.filters, ...filters };
    },
    setExecutiveSummaryPagination(state, pagination) {
      state.pagination = { ...state.pagination, ...pagination };
    },
    resetExecutiveSummaryFilters(state) {
      state.filters = getDefaultState().filters;
      state.pagination = getDefaultState().pagination;
    },
    resetExecutiveSummaryState(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async fetchExecutiveSummary({ state, commit, getters }) {
      commit("setExecutiveSummaryLoading", true);
      try {
        const user = getters.getUser;
        if (!user) {
          throw new Error("User not authenticated");
        }

        const params = {
          user_id: user.id,
          workspace_id: getters.selectedWorkspace.id,
          offset: state.pagination.offset,
          limit: state.pagination.limit,
        };

        if (state.filters.search) {
          params.search = state.filters.search;
        }
        if (state.filters.url) {
          params.url = state.filters.url;
        }
        if (state.filters.dateFrom) {
          params.date_from = state.filters.dateFrom;
        }
        if (state.filters.dateTo) {
          params.date_to = state.filters.dateTo;
        }

        const { data } = await axios.get(
          "tools/category_cards/executive_summary",
          { params }
        );

        commit("setExecutiveSummaryTasks", data.data || []);
        commit("setExecutiveSummaryRecordsTotal", data.recordsTotal || 0);
      } catch (error) {
        console.error("Cannot fetch executive summary", error);
        Message({
          showClose: true,
          message: error.response?.data?.message || "Error fetching data",
          type: "error",
        });
        commit("setExecutiveSummaryTasks", []);
        commit("setExecutiveSummaryRecordsTotal", 0);
      } finally {
        commit("setExecutiveSummaryLoading", false);
      }
    },
  },
};

export default moduleExecutiveSummary;
